import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import BreachRiskClassificationForm from '../Forms/BreachRiskClassificationForm';

const AddEditBreachRiskClassificationModal = ({
	dataBreachRiskClassification,
	isOpen,
	isEdit,
	handleToggleModal,
	toggleRefetch,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xs'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Clasificación de Riesgo
			</ModalHeader>

			<BreachRiskClassificationForm
				dataBreachRiskClassification={dataBreachRiskClassification}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				toggleRefetch={toggleRefetch}
			/>
		</Modal>
	);
};

export default AddEditBreachRiskClassificationModal;
